<template>
	<div class="invite-container">
		<div class="content">
			<div class="head">
				<div class="close" @click="$router.back()"></div>
				<div class="title"></div>
			</div>
			<VImage :src="require('@/assets/logo-white.png')" class="logo" />
			<div class="phone">
				<span class="number">{{ phone_c }}</span>
				<span class="label">用户</span>
			</div>
			<div class="btn-invite-code">
				<Field class="input" v-model="inviteCode" placeholder="输入邀请码" maxlength="6" autofocus />
			</div>
			<div class="btn-enter" @click="register">点击进入</div>
			<div class="tip">无邀请码请联系您的上级</div>
		</div>
		<!-- 详细信息弹窗 -->
		<van-dialog v-model="userInfoShow" title="请完善信息" show-cancel-button :before-close="closeDialog" @confirm="registerDistributor" @cancel="rulesTipHide = true">
      <van-form ref="reference">
				<van-field v-model="userInfo.realName" required label="真实姓名" placeholder="请输入真实姓名" :error-message="userInfo.realName||rulesTipHide?'':'请输入真实姓名'" />
				<van-field v-model="userInfo.wxName" required label="微信名" placeholder="请输入微信名" :error-message="userInfo.wxName||rulesTipHide?'':'请输入微信名'" />
				<van-field v-model="userInfo.birthday" required label="出生年月" readonly placeholder="请选择出生年月" @click="popupShow = true" :error-message="userInfo.birthday||rulesTipHide?'':'请选择出生年月'" />
				<van-field v-model="userInfo.occupation" required label="职业" placeholder="请输入职业" :error-message="userInfo.occupation||rulesTipHide?'':'请输入职业'" />
				<van-field v-model="userInfo.companyName" required label="公司名称" placeholder="请输入公司名称" :error-message="userInfo.companyName||rulesTipHide?'':'请输入公司名称'" />
				<van-field v-model="userInfo.companyAddress" type="textarea" :autosize="{ maxHeight: 80 }" required label="公司地址" placeholder="请输入公司地址" :error-message="userInfo.companyAddress||rulesTipHide?'':'请输入公司地址'" />
				<van-field v-model="userInfo.deliveryAddress" type="textarea" :autosize="{ maxHeight: 80 }" required label="收货地址" placeholder="请输入收货地址" :error-message="userInfo.deliveryAddress||rulesTipHide?'':'请输入收货地址'" />
      </van-form>
		</van-dialog>
		<van-popup v-model="popupShow" position="bottom">
			<van-datetime-picker v-model="pickerValue" type="date" :min-date="minDate"   @confirm="pickerConfirm" @cancel="pickerCancel"/>
		</van-popup>
	</div>
</template>

<script>
import { Image as VImage, Field, Toast } from 'vant'
import { registerDistributor, registerCustomer } from '@/api/login'
import dayjs from "dayjs";

export default {
  components: { VImage, Field },
  data() {
    return {
      loading: false,
      phone: this.$route.query.phone,
      code: this.$route.query.code,
      inviteCode: this.$route.query.invitationCode,
      customerId: this.$route.query.customerId,
      password: this.$route.query.password,
      redirect: undefined,
      otherQuery: {},
      userInfoShow: false,
      popupShow: false,
      userInfo:{
        birthday: null,
        realName: null,
        wxName: null,
        occupation: null,
        companyName: null,
        companyAddress: null,
        deliveryAddress: null,
      },
      pickerValue: dayjs('2000-01-01').$d,
      minDate: dayjs().subtract(100, 'year').$d,
      rulesTipHide: true,
    }
  },
  $route: {
    handler: function (route) {
      const query = route.query
      if (query) {
        this.redirect = query.redirect
        this.otherQuery = this.getOtherQuery(query)
      }
    },
    immediate: true,
  },
  computed: {
    phone_c() {
      return this.phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
    },
  },
  methods: {
    register() {
      if (this.inviteCode) {
        this.userInfoShow = true
        // this.registerDistributor()
      } else {
        Toast.fail('请输入邀请码')
      }
    },
    // 时间处理
    pickerConfirm(value) {
      this.userInfo.birthday = dayjs(value).format('YYYY-MM-DD')
      this.popupShow = false
    },
    pickerCancel() {
      this.pickerValue = dayjs('2000-01-01').$d
      this.popupShow = false
    },
    // 关闭前弹窗回调
    closeDialog(action,done) {
      if (action === 'confirm') {
        for  (let  key  in  this.userInfo) {
          if  (this.userInfo.hasOwnProperty(key) &&  (this.userInfo[key]  ===  ""||  this.userInfo[key]  ===  null)) {
            this.rulesTipHide = false
            done(false)
            return
        }}
      done()
      }else{
        done()
      }
    },
    // 注册分销员
    registerDistributor() {
      for(let  key  in  this.userInfo) {
        if  (this.userInfo.hasOwnProperty(key) &&  (this.userInfo[key]  ===  ""||  this.userInfo[key]  ===  null)) {
          this.rulesTipHide = false
          return
      }}
      let su = this.$route.query.su
      if (su && Array.isArray(su)) {
          su = su[0]
      }
      const params = {
        code: this.code,
        mobile: this.phone,
        inviteCode: this.inviteCode,
        password: this.password,
        su: su,
        ...this.userInfo
      }
      this.$store.dispatch('app/showLoading')
      registerDistributor(params)
        .then((res) => {
          this.$store.dispatch('user/setLoginInfo', res.data)
          this.$store.dispatch('app/hideLoading')
          this.$store.dispatch('sms/resetCode')
          Toast.success('注册成功')
          this.$router.push({
            path: this.redirect || '/',
            query: this.otherQuery,
          })
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
    // 注册顾客
    registerCustomer() {
      const params = {
        code: this.code,
        mobile: this.phone,
        customerId: this.customerId,
        password: this.password
      }
      this.$store.dispatch('app/showLoading')
      registerCustomer(params).then(res => {
        this.$store.dispatch('user/setLoginInfo', res.data)
        this.$store.dispatch('app/hideLoading')
        this.$store.dispatch('sms/resetCode')
        Toast.success('注册成功')
        this.$router.push({
          path: this.redirect || '/',
          query: this.otherQuery,
        })
      })
      .catch(() => {
        this.$store.dispatch('app/hideLoading')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.invite-container {
	position: relative;
	height: 100vh;
	width: 100vw;
	background: #c82d26;
	display: flex;
	align-items: center;
	.head {
		display: flex;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		padding: 30px 40px;
		.close {
			display: inline-block;
			width: 30px;
			height: 4px;
			background: #fff;
			border-radius: 4px;
			transform: rotate(45deg);
			&::after {
				content: '';
				display: block;
				width: 30px;
				height: 4px;
				background: #fff;
				border-radius: 4px;
				transform: rotate(-90deg);
			}
		}
		.title {
			flex: 1;
			font-size: 28px;
			line-height: 1;
			height: 28px;
			text-indent: -20px;
		}
	}
	.content {
		width: 100%;
		padding: 0 74px;
		padding-bottom: 160px;
	}
	.logo {
		width: 366px;
		margin-bottom: 152px;
	}
	.phone {
		color: #fff;
		padding-bottom: 40px;
		font-size: 48px;
		line-height: 66px;
		font-weight: bold;
	}
	.btn-invite-code {
		background: #fff;
		color: #c82d26;
		margin-bottom: 40px;
		border-radius: 80px;
		padding: 4px 0;
		overflow: hidden;
		.input {
			font-size: 26px;
			line-height: 26px;
		}
		.input /deep/ input {
			text-align: center;
			color: #c82d26;
			&::placeholder {
				color: #c82d26;
			}
		}
	}
	.btn-enter {
		border-radius: 80px;
		text-align: center;
		font-weight: bold;
		font-size: 26px;
		line-height: 80px;
		color: #fff;
		border: 1px solid #fff;
		box-sizing: border-box;
	}
	.tip {
		font-size: 26px;
		font-weight: 500;
		color: #ffffff;
		line-height: 36px;
		margin-top: 40px;
	}
}
</style>
